import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, FilterDropdown, StatusComponent } from "../../../common/component/Index";
import ObjectType from './../../../../../models/ObjectType';
import { withTranslation } from "react-i18next";
import { Icon, Menu, Tooltip } from 'antd';
import { DATE_TIME_FORMAT, ORDER, PATHS, TRANSLATE_LANGUAGE } from '../../../../../constants/Define';
import moment from "moment";
import Dropdown from '../../../common/component/Dropdown';
import Modal from '../../../common/component/Modal';
import { FlagIcons } from '../../../common/component/TranslateButton';
import { find, toArray } from 'lodash'
import EllipsisText from '../../../common/component/EllipsisText';
import FontIcon, { SolidIcons } from '../../../common/component/FontIcon';
import Span from '../../../common/component/Span';

const ListCols = ['id', 'code', 'name', 'types', 'description', 'isAvailable', 'createdDate', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new ObjectType());

class ObjectTypeLIst extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], ['id']),
            modelItem: ModelFields,
            componentTable: {
                name: {
                    key: 'name',
                    sorter: (i, k) => i.name.length - k.length,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                isAvailable: {
                    width: 250,
                    key: 'isAvailable',
                    render: (isActive) => (
                        <StatusComponent color={isActive ? 'green' : 'red'}
                            label={isActive ? this.props.t('item.promotions.active') : this.props.t('item.promotions.deactive')} />
                    ),
                    filters: [
                        { value: true, text: this.props.t('item.promotions.active') },
                        { value: false, text: this.props.t('item.promotions.deactive') }
                    ],
                    filterMultiple: false,
                },
                description: {
                    key: 'description',
                    render: (text, record) => <EllipsisText title={'text'} content={text} contentMaxWidth={280}
                    overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                types: {
                    key: 'types',
                    render: (types, record) => (
                        <Fragment>
                            {(types || []).map(typeProd => {
                                const typeKey = find(Object.keys(ORDER.TYPES), k => ORDER.TYPES[k].id === typeProd)
                                return typeKey && <Tooltip key={typeKey} title={this.props.t(`item.order.orderTypes.${ORDER.TYPES[typeKey].key}`)}><Span className="ml-2">
                                    <FontIcon key={typeProd} color={ORDER.TYPES[typeKey].color} icon={SolidIcons[ORDER.TYPES[typeKey].icon]} size="lg" />
                                </Span></Tooltip>
                            })}
                        </Fragment>
                    ),
                    filters: [
                        { value: ORDER.TYPES['VOUCHER'].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES['VOUCHER'].key}`) },
                        { value: ORDER.TYPES['TOUR'].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES['TOUR'].key}`) },
                        { value: ORDER.TYPES['VINWONDER_NEW'].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES['VINWONDER_NEW'].key}`) },
                    ],
                    filterMultiple: true,
                },
                createdDate: {
                    key: 'createdDate',
                    render: (date, record) => date && moment(moment.utc(date).toDate()).format(DATE_TIME_FORMAT.DATE_TIME)
                },
                translations: {
                    key: 'languageCode',
                    filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                        value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                    })),
                    filterMultiple: false,
                    width: 120,
                    render: (text, record) => <FlagIcons languages={record.translations} />,
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
        };
    }

    render() {
        const { loading, pagination, objectTypes } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <ListComponent
                tableKey="objectTypes-list"
                classChildren="p-0" classParent="m-0"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(objectTypes || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'objectType'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
                onColumnVisibleChange={this.onColumnVisibleChange}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeObjectType = () => {
            return this.props.onDelete && this.props.onDelete(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.objectType.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeObjectType,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.OBJECT_TYPES.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }
                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }

    getTableColumns() {
        return Func.getTitleTable(['name', 'key', 'value', 'createdDate', 'translations'], ['action'], []);
    }

    componentDidMount(){
        // getColumnVisibleConfigs(ListKeyString, this.state.componentTable);
    }

    onColumnVisibleChange = (column, isVisibled) => {
        const { componentTable } = this.state;
        componentTable[column.dataIndex].visible = isVisibled;
        // setColumnVisibleConfigs(ListKeyString, componentTable);
        this.setState({ componentTable })
    }


}

export default withTranslation()(ObjectTypeLIst);
